import { Centralized } from "@modules/Auth/CMS/Centralized";
import { CMS } from "@modules/Auth/CMS/CMS";
import { Dedicated } from "@modules/Auth/CMS/Dedicated";
import { AddNewDedicatedUser } from "@modules/Dedicated/UserManagement/AddNewDedicatedUser";
import { DedicatedUserManagement } from "@modules/Dedicated/UserManagement/DedicatedUserManagement";
import { ApprovalManagement } from "@modules/ECMS/MAGP/ApprovalManagement/ApprovalManagement";
import { Home } from "@modules/ECMS/MAGP/Forms/Popup/Home";
import { StatusInformation } from "@modules/ECMS/MAGP/StatusInformation/StatusInformation";
import { Login } from "@modules/index";
import { LandingPage } from "@modules/UserManagement/NewUser/LandingPage/LandingPage";
import { RequestAccess } from "@modules/UserManagement/NewUser/RequestAccess/RequestAccess";
import { ReactNode } from "react";
import { MAGPAccessManagement } from "~/Modules/ECMS/MAGP/AccessManagement/AccessManagement";
import { AddEditAnnouncement } from "~/Modules/ECMS/MAGP/Announcement/AddEditAnnouncement";
// import { Announcement } from "@modules/ECMS/MAGP/Forms/Announcements/Announcement";
import { AddEditNewFAQ } from "@modules/ECMS/MAGP/Forms/FAQ/AddEditNewFAQ";
import { FAQ } from "@modules/ECMS/MAGP/Forms/FAQ/FAQ";
import { LoginMAGP } from "@modules/ECMS/MAGP/Forms/Login/Login";
import { Manual } from "@modules/ECMS/MAGP/Forms/Manual/Manual";
import { Others } from "@modules/ECMS/MAGP/Forms/Others/Others";
import { Profile } from "@modules/ECMS/MAGP/Forms/Profile/Profile";
import DefaultModule from "~/Modules/DefaultModule";
import { Advertisement } from "~/Modules/ECMS/ERAMAN/Forms/Advertisement/Advertisement";
import { Configuration } from "~/Modules/ECMS/ERAMAN/Forms/Configuration/Configuration";
import { AddEditNewEdmMailer } from "~/Modules/ECMS/ERAMAN/Forms/Configuration/EDMMailer/AddEditEdmMailer";
import { AddEditNewUsers } from "~/Modules/ECMS/ERAMAN/Forms/Configuration/Users/AddEditUsers";
import { EramanDashboard } from "~/Modules/ECMS/ERAMAN/Forms/Dashboard/Dashboard";
import { Footer } from "~/Modules/ECMS/ERAMAN/Forms/Footer/Footer";
import { FormsSubmissions } from "~/Modules/ECMS/ERAMAN/Forms/FormsSubmissions/FormsSubmissions";
import { Header } from "~/Modules/ECMS/ERAMAN/Forms/Header/Header";
import { Members } from "~/Modules/ECMS/ERAMAN/Forms/Members/Members";
import { AddEditMembers } from "~/Modules/ECMS/ERAMAN/Forms/Members/Members/AddEditMembers";
import { Pages } from "~/Modules/ECMS/ERAMAN/Forms/Pages/Pages";
import { ProductManagement } from "~/Modules/ECMS/ERAMAN/Forms/ProductManagement/ProductManagement";
import { ProductReviews } from "~/Modules/ECMS/ERAMAN/Forms/ProductReviews/ProductReviews";
import { UserTransactions } from "~/Modules/ECMS/ERAMAN/Forms/UserTransactions/UserTransactions";
import { Dashboard } from "~/Modules/ECMS/MAGP/Dashboard/Dashboard";
import { EditContractAdministrationProcessFlowChart } from "~/Modules/ECMS/MAGP/Forms/Manual/ContractAdministration/EditContractAdministrationProcessFlowChart";
import { EditProcurementPlanningProcessFlowChart } from "~/Modules/ECMS/MAGP/Forms/Manual/ProcurementPlanning/EditProcurementPlanningProcessFlowChart";
import { EditRequisitionProcessFlowChart } from "~/Modules/ECMS/MAGP/Forms/Manual/Requisition/EditRequisitionProcessFlowChart";
import { EditSourcingProcessFlowChart } from "~/Modules/ECMS/MAGP/Forms/Manual/Sourcing/EditSourcingProcessFlowChart";
import { EditVendorManagementProcessFlowChart } from "~/Modules/ECMS/MAGP/Forms/Manual/VendorManagement/EditVendorManagementProcessFlowChart";
import { MAGPUserManagement } from "~/Modules/ECMS/MAGP/UserManagement/MAGPUserManagement";
import { ButterflyEffect } from "~/Modules/ECMS/PASSENGER/ButterflyEffect";
import { FooterPassenger } from "~/Modules/ECMS/PASSENGER/footer/FooterPassenger";
import { HomepageManagement } from "~/Modules/ECMS/PASSENGER/homepage/HomepageManagment";
import { MobileApp } from "~/Modules/ECMS/PASSENGER/mobileapp/MobileApp";

import { PASSENGERUserManagement } from "~/Modules/ECMS/PASSENGER/UserManagement/PassengerUserManagement";

// import { AddEditEpcApplications } from "~/Modules/ECMS/ERAMAN/Forms/FormsSubmissions/EPCApplications/AddEditEpcApplications";
import { PassengerAirports } from "~/Modules/Auth/CMS/PassengerAirports";
import { ConfirmNewPassword } from "~/Modules/Auth/Login/ConfirmPassword";
import { ForgotPasswordPage } from "~/Modules/Auth/Login/ForgotPassword";
import { GetLoginPassword } from "~/Modules/Auth/Login/GetPassword";
import { OtpPasswordPage } from "~/Modules/Auth/Login/OtpForgotPasswordPage";
import { OtpLoginPage } from "~/Modules/Auth/Login/OtpLogin";
import { ResetPasswordPage } from "~/Modules/Auth/Login/ResetPassword";
import { AddEditCorporateAwards } from "~/Modules/ECMS/CORPORATE/Forms/Awards/AddEditAwards";
import { Awards } from "~/Modules/ECMS/CORPORATE/Forms/Awards/Awards";
import { AddEditAirlineServicesAndIncentives } from "~/Modules/ECMS/CORPORATE/Forms/BusinessOppurtunities/AirlineServices/AirlineServicesAndIncentives/AddEditAirlineServicesAndIncentives";
import { BusinessOppurtunities } from "~/Modules/ECMS/CORPORATE/Forms/BusinessOppurtunities/BusinessOppurtunities";
import { AddEditCommercialLeasingOpportunities } from "~/Modules/ECMS/CORPORATE/Forms/BusinessOppurtunities/CommericialLeasingOppurtunites/AddEditCommercialLeasingOpportunities";
import ContactUs from "~/Modules/ECMS/CORPORATE/Forms/ContactUS/ContactUs";
import { CorporateIntegrity } from "~/Modules/ECMS/CORPORATE/Forms/CorporateIntegrity/CorporateIntegrity";
import { CorporateProfile } from "~/Modules/ECMS/CORPORATE/Forms/CorporateProfile/CorporateProfile";
import Homepage from "~/Modules/ECMS/CORPORATE/Forms/Homepage/Homepage";
import { AddEditCorporatesHomepage } from "~/Modules/ECMS/CORPORATE/Forms/Homepage/HomepageBanner/AddEditHomepageBanner";
import AddEditPublications from "~/Modules/ECMS/CORPORATE/Forms/Homepage/Publications/AddEditPublications";
import { AddEditSpotlightLargecards } from "~/Modules/ECMS/CORPORATE/Forms/Homepage/SpotLight/LargeCards/AddEditLargeCard";
import { AddEditSpotlightSmallcards } from "~/Modules/ECMS/CORPORATE/Forms/Homepage/SpotLight/SmallCards/AddEditSmallcard";
import MalaysiaAirportAcademy from "~/Modules/ECMS/CORPORATE/Forms/MalaysiaAirportAcademy/MalaysiaAirportAcademy";
import { MediaCentre } from "~/Modules/ECMS/CORPORATE/Forms/MediaCentre/MediaCentre";
import { AddEditCorporateNews } from "~/Modules/ECMS/CORPORATE/Forms/MediaCentre/News/AddEditNews";
import { AddEditChildHeader } from "~/Modules/ECMS/CORPORATE/Forms/Navigation/ChildHeader/AddEditChildHeader";
import { AddEditGrandChildHeader } from "~/Modules/ECMS/CORPORATE/Forms/Navigation/GrandChildHeader/AddEditGrandChildHeader";
import { AddEditParentHeader } from "~/Modules/ECMS/CORPORATE/Forms/Navigation/ParentHeader/AddEditParentHeader";
import { AddEditBoardOfDirectors } from "~/Modules/ECMS/CORPORATE/Forms/Organization/BoardOfDirectors/AddEditBoardOfDirectors";
import { AddEditManagementTeam } from "~/Modules/ECMS/CORPORATE/Forms/Organization/ManagementTeam/AddEditManagementTeam";
import { Organization } from "~/Modules/ECMS/CORPORATE/Forms/Organization/Organization";
import { AddEditAgencies } from "~/Modules/ECMS/CORPORATE/Forms/StakeHolders/Agencies/AddEditAgencies";
import { AddEditAirlines } from "~/Modules/ECMS/CORPORATE/Forms/StakeHolders/Airlines/AddEditAirlines";
import { AddEditCargo } from "~/Modules/ECMS/CORPORATE/Forms/StakeHolders/Cargo/AddEditCargo";
import { AddEditGroundHolders } from "~/Modules/ECMS/CORPORATE/Forms/StakeHolders/GroundHolders/AddEditGroundHolders";
import { StakeHolder } from "~/Modules/ECMS/CORPORATE/Forms/StakeHolders/StakeHolder";
import Sustainbility from "~/Modules/ECMS/CORPORATE/Forms/Sustainbility/Sustainbility";
import { AddEditMilestones } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/Milestones/AddEditMilestones";
import { AddEditTrainingAcademyNews } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/News/AddEditNews";
import { TrainingAcademy } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/TrainingAcademy";
import { AddEditTrainingFacilities } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/TrainingFacilities/AddEditTrainingFacilities";
import { AddEditHomePageCarousel } from "~/Modules/ECMS/ERAMAN/Forms/Advertisement/HomePageCarousel/AddEditHomePageCarousel";
import { AddEditNewPromotions } from "~/Modules/ECMS/ERAMAN/Forms/Advertisement/Promotions/AddEditPromotions";
import { AddNewsLetter } from "~/Modules/ECMS/ERAMAN/Forms/Configuration/NewsLetter/AddNewsLetter";
import { AddEditPromotions } from "~/Modules/ECMS/ERAMAN/Forms/Configuration/Promotions/AddEditpromotions";
import { Contents } from "~/Modules/ECMS/ERAMAN/Forms/Contents/Contents";
import { AddEditEpcApplications } from "~/Modules/ECMS/ERAMAN/Forms/EPCApplications/AddEditEpcApplications";
import { EpcApplications } from "~/Modules/ECMS/ERAMAN/Forms/EPCApplications/EpcApplications";
import { AddEditContent } from "~/Modules/ECMS/ERAMAN/Forms/Footer/Content/AddEditContent";
import { AddEditSocialMediaIcons } from "~/Modules/ECMS/ERAMAN/Forms/Footer/SocialMediaIcons/AddEditSocialMediaIcons";
import { Participants } from "~/Modules/ECMS/ERAMAN/Forms/FormsSubmissions/Contests/Participants";
import { AddEditCategoryBanner } from "~/Modules/ECMS/ERAMAN/Forms/Header/CategoryBanner/AddEditCategoryBanner";
import { EditMenuHeader } from "~/Modules/ECMS/ERAMAN/Forms/Header/MenuHeader/EditMenuHeader";
import { AddEditAwards } from "~/Modules/ECMS/ERAMAN/Forms/Pages/AboutEraman/Awards/AwardList/AddEditAwards";
import { AddEditJobOpportunities } from "~/Modules/ECMS/ERAMAN/Forms/Pages/AboutEraman/Careers/JobOpportunities/AddEditJobOpportunities";
import { AddEditNews } from "~/Modules/ECMS/ERAMAN/Forms/Pages/AboutEraman/News/AddEditNews";
import { AddEditEramanFaqs } from "~/Modules/ECMS/ERAMAN/Forms/Pages/EramanPrivilegeCard/Faqs/AddEditEramanFaqs";
import { AddEditDutyFreeBuyingGuide } from "~/Modules/ECMS/ERAMAN/Forms/Pages/TravellersInfo/DutyFreeBuyingGuide/AddEditDutyFreeBuyingGuide";
import { AddEditGuidelinesForCheckedInSection2 } from "~/Modules/ECMS/ERAMAN/Forms/Pages/TravellersInfo/GuidelinesForCheckedIn/AddEditGuidelinesForCheckedInSection2";
import { AddEditLagsSection2 } from "~/Modules/ECMS/ERAMAN/Forms/Pages/TravellersInfo/LagsSection/AddEditLagsSection2";
import { AddEditRestrictedItemsSectionsList } from "~/Modules/ECMS/ERAMAN/Forms/Pages/TravellersInfo/RestrictedItemsSection/AddEditRestrictedItemsSectionsList";
import { AddEditSingleCabinLuggagePolicySection2 } from "~/Modules/ECMS/ERAMAN/Forms/Pages/TravellersInfo/SingleCabinLuggagePolicySection/AddEditSingleCabinLuggagePolicySection2";
import { AddEditBrands } from "~/Modules/ECMS/ERAMAN/Forms/ProductManagement/Brands/AddEditBrand";
import { AddEditCategories } from "~/Modules/ECMS/ERAMAN/Forms/ProductManagement/Categories/AddEditCategories";
import { AddEditFAndBAddEditCategory } from "~/Modules/ECMS/ERAMAN/Forms/ProductManagement/F&B/AddEditFandBCategory";
import { FAndBAddEditBrand } from "~/Modules/ECMS/ERAMAN/Forms/ProductManagement/F&B/FAndBAddEditBrand";
import { FAndBAddEditOutlet } from "~/Modules/ECMS/ERAMAN/Forms/ProductManagement/F&B/FAndBAddEditOutlet";
import { AddEditProducts } from "~/Modules/ECMS/ERAMAN/Forms/ProductManagement/Products/AddEditProducts";
import { AddEditSubCategories } from "~/Modules/ECMS/ERAMAN/Forms/ProductManagement/SubCategories/AddEditSubCategories";
import { AddEditStoreAirport } from "~/Modules/ECMS/ERAMAN/Forms/StoreLocations/Airport/AddEditAirpot";
import { AddEditStoreLevel } from "~/Modules/ECMS/ERAMAN/Forms/StoreLocations/Levels/AddEditLevel";
import { AddEditStoreOutlet } from "~/Modules/ECMS/ERAMAN/Forms/StoreLocations/Outlet/AddEditOutlet";
import { StoreLocations } from "~/Modules/ECMS/ERAMAN/Forms/StoreLocations/StoreLocations";
import { EramanUserManagement } from "~/Modules/ECMS/ERAMAN/UserManagement/EramanUserManagement";
import { CorporateApprovalManagement } from "~/Modules/ECMS/MAGP/ApprovalManagement/CorporateApprovalManagement";
import { PassengerApprovalManagement } from "~/Modules/ECMS/MAGP/ApprovalManagement/PassengerApprovalManagement";
import { Announcement } from "~/Modules/ECMS/MAGP/Forms/Announcements/Announcement";
import { AddEditNewCircular } from "~/Modules/ECMS/MAGP/Forms/Announcements/Circular/AddEditNewCircular";
import { AddEditNewGeneral } from "~/Modules/ECMS/MAGP/Forms/Announcements/General/AddEditNewGeneral";
import { ContractDirectory } from "~/Modules/ECMS/MAGP/Forms/ContractDirectory/ContractDirectory";
import { AddEditWebLoginPage } from "~/Modules/ECMS/MAGP/Forms/Login/WebLoginPage/AddEditWebLoginPage";
import { AddEditMobileHomepageBannerSlider } from "~/Modules/ECMS/MAGP/Forms/Others/Banners/MobileHomepageBannerSlider/AddEditMobileHomepageBannerSlider";
import { AddEditWebBannerImages } from "~/Modules/ECMS/MAGP/Forms/Others/Banners/WebBannerImages/AddEditWebBannerImages";
import { AddEditHyperlink } from "~/Modules/ECMS/MAGP/Forms/Popup/HyperLink/AddEditHyperLink";
import { AddNewGallery } from "~/Modules/ECMS/MAGP/Gallery/GalleryList/AddNewGallery";
import { GalleryList } from "~/Modules/ECMS/MAGP/Gallery/GalleryList/GalleryList";
import { AddNewCD } from "~/Modules/ECMS/MAGP/Forms/ContractDirectory/AddCDmain";
import { AddEdit } from "~/Modules/ECMS/MAGP/Forms/ContractDirectory/DynamicCD/AddEdit";
import AddEditSlider from "~/Modules/ECMS/PASSENGER/homepage/Slider/AddEditslider";
import AddEditcards from "~/Modules/ECMS/PASSENGER/homepage/Spotlight/AddEditcards";
import AddEditHighlight from "~/Modules/ECMS/PASSENGER/homepage/Spotlight/AddEditHighlight";
import AddEditPage from "~/Modules/ECMS/PASSENGER/homepage/Spotlight/AddEditPage";
import AddEditTravllerEssential from "~/Modules/ECMS/PASSENGER/homepage/TravllerEssential/AddEditTravllerEssential";
import AddEditusefullTip from "~/Modules/ECMS/PASSENGER/homepage/UsefullTips/AddEditusefullTips";

import AddEditFeature from "~/Modules/ECMS/PASSENGER/mobileapp/appfeature/AddEditFeature";

import { Help } from "~/Modules/ECMS/PASSENGER/Help/Help";
import { AddEditPageContent } from "~/Modules/ECMS/PASSENGER/Help/PageContent/AddEditPageContent";
import AddEditYouTube from "~/Modules/ECMS/PASSENGER/homepage/Youtube/AddEditYouTube";
import { AddEditAirportLocation } from "~/Modules/ECMS/PASSENGER/Maps/AirportLocation/AddEditAirportLocation";
import { AddEditChildAirport } from "~/Modules/ECMS/PASSENGER/Maps/ChildAirport/AddEditChildAirport";
import { Maps } from "~/Modules/ECMS/PASSENGER/Maps/Maps";
import { AddEditParentAirport } from "~/Modules/ECMS/PASSENGER/Maps/ParentAirport/AddEditParentAirport";
import { ShopAndDine } from "~/Modules/ECMS/PASSENGER/ShopAndDine/ShopAndDine";

import { MainNavigation } from "~/Modules/ECMS/CORPORATE/Forms/MainNavigation/MainNavigation";
import AddEditFooterLogo from "~/Modules/ECMS/PASSENGER/footer/FooterLogo/AddEditFooterLogo";
import AddEditFooterWebsite from "~/Modules/ECMS/PASSENGER/footer/FooterWebsite/AddEditFooterWebsite";
import AddEditChildHeaderPas from "~/Modules/ECMS/PASSENGER/Header/childheader/AddEditChildHeaderPas";
import AddEditGrandChildHeaderPas from "~/Modules/ECMS/PASSENGER/Header/grandchildheader/AddEditGrandChildHeaderPas";
import AddEditCardHeaderPas from "~/Modules/ECMS/PASSENGER/Header/HeaderCard/AddEditCardHeaderPas";
import AddEditMainHeaderPas from "~/Modules/ECMS/PASSENGER/Header/mainheader/AddEditMainHeaderPas";

import { AddEditChildMenus } from "~/Modules/ECMS/CORPORATE/Forms/MainNavigation/ChildMenus/AddEditChildMenus";
import { AddEditGrandChildMenus } from "~/Modules/ECMS/CORPORATE/Forms/MainNavigation/GrandChildMenus/AddEditGrandGrandChildMenus";
import { AddEditMainMenu } from "~/Modules/ECMS/CORPORATE/Forms/MainNavigation/MainMenu/AddEditMainMenu";
import { AddEditTrainingAcademyBanner } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/Banner/AddEditTraningAcademyBanner";
import { AddEditInternationalClients } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/OurClients/InternationalClients/AddEditInternationalClients";
import { AddEditLocalClients } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/OurClients/LocalClients/AddEditLocalClients";
import { Flightinfo } from "~/Modules/ECMS/PASSENGER/FlightInfo/FlightInfo";
import { AddEditFlightinfo } from "~/Modules/ECMS/PASSENGER/FlightInfo/PageContent/AddEditFlightinfo";
import { AddEditHeader } from "~/Modules/ECMS/PASSENGER/PageHeader/PageHeader/AddEditHeader";
// import {HeaderPassenger} from "~/Modules/ECMS/PASSENGER/Header/HeaderPassanger";
import { AddEditCentralizedAirlineImages } from "~/Modules/Centralized/Forms/AirlineImages/AddEditAirlineImages";
import { CentralisedAirlineImages } from "~/Modules/Centralized/Forms/AirlineImages/AirlineImages";
import { AddEditCentralizedBanner } from "~/Modules/Centralized/Forms/Banner/AddEditBanner";
import { CentralizedBannerTab } from "~/Modules/Centralized/Forms/Banner/BannerTab";
import { AddEditCentralizedBannerTags } from "~/Modules/Centralized/Forms/Banner/CentralizedBannerTags/AddEditCentralizedBannerTags";
import { AddEditCentralizedBannerType } from "~/Modules/Centralized/Forms/Banner/CentralizedBannerType/AddEditCentralizedBannerType";
import { CentralizedApprovalManagement } from "~/Modules/Centralized/Forms/CentralizedApprovalManagement";
import { CentralizedStatusInformation } from "~/Modules/Centralized/Forms/CentralizedStatusInformation";
import { AddEditCentralizedFaqs } from "~/Modules/Centralized/Forms/FAQs/AddEditFAQs";
import { CentralizedFaqsTab } from "~/Modules/Centralized/Forms/FAQs/FAQsTab";
import { AddEditCentralisedKeyInfoBanner } from "~/Modules/Centralized/Forms/FAQs/KeyInfoBanner/AddEditCentralizedKeyInfoBanner";
import { AddEditCentralisedKeyInfoList } from "~/Modules/Centralized/Forms/FAQs/KeyInfoList/AddEditCentralizedKeyInfoList";
import { AddEditCentralizedModules } from "~/Modules/Centralized/Forms/Modules/AddEditCentralizedModules";
import { CentralizedModules } from "~/Modules/Centralized/Forms/Modules/CentralizedModules";
import AddEditMyAirports from "~/Modules/Centralized/Forms/PrivacyPolicy/MyAirports/AddEditMyAirports";
import { CentralisedPrivacyPolicy } from "~/Modules/Centralized/Forms/PrivacyPolicy/PrivacyPolicyManagement";
import AddEditTabOne from "~/Modules/Centralized/Forms/PrivacyPolicy/TabOne/AddEditTabOne";
import AddEditTabOnePara from "~/Modules/Centralized/Forms/PrivacyPolicy/TabOneParagraph/AddEditTabOnePara";
// import AddEditTabTwo from "~/Modules/Centralized/Forms/PrivacyPolicy/TabTwo/AddEditTabTwo";
// import AddEditTabTwoPara from "~/Modules/Centralized/Forms/PrivacyPolicy/TabTwoParagraph/AddEditTabTwoPara";
import { AddEditGeoLocation } from "~/Modules/Centralized/Forms/MyAiportsPromotions/GeoLocation/AddEditGeoLocation";
import { AddEditGeoLocationLevels } from "~/Modules/Centralized/Forms/MyAiportsPromotions/GeoLocationLevels/AddEditGeoLocationLevels";
import { AddEditGeoLocationPromotion } from "~/Modules/Centralized/Forms/MyAiportsPromotions/GeoLocationPromotion/AddEditGeoLocationPromotion";
import { MyAirportsPromotionsManagement } from "~/Modules/Centralized/Forms/MyAiportsPromotions/MyAirportsPromotion";
import { AddEditNotificationType } from "~/Modules/Centralized/Forms/MyAiportsPromotions/NoticationType/AddEditNotificationType";
import { AddEditMyairportsPromotion } from "~/Modules/Centralized/Forms/MyAiportsPromotions/Promotions/AddEditPromotion";
import { AddEditRepeatType } from "~/Modules/Centralized/Forms/MyAiportsPromotions/RepeatType/AddEditRepeatType";
import { AddEditCentralizedPromotions } from "~/Modules/Centralized/Forms/Promotions/AddEditPromotions";
import { CentralisedPromotions } from "~/Modules/Centralized/Forms/Promotions/Promotions";
import { CentralizedAddEditBrand } from "~/Modules/Centralized/Forms/ShopAndDine/Brands/AddEditBrands";
import { CentralizedAddEditCategory } from "~/Modules/Centralized/Forms/ShopAndDine/Category/AddEditCategory";
import { CentralizedAddEditClassification } from "~/Modules/Centralized/Forms/ShopAndDine/Classification/AddEditClassification";
import { CentralizedAddEditDineCatPageContent } from "~/Modules/Centralized/Forms/ShopAndDine/Dine/DineCategories/AddEditDineCatPageContent";
import { CentralizedAddEditDineListPageContent } from "~/Modules/Centralized/Forms/ShopAndDine/Dine/DineList/AddEditDineListPageContent";
import { CentralizedAddEditList } from "~/Modules/Centralized/Forms/ShopAndDine/List/AddEditList";
import { CentralizedAddEditLocation } from "~/Modules/Centralized/Forms/ShopAndDine/Location/AddEditLocation";
import { CentralizedAddEditRedirect } from "~/Modules/Centralized/Forms/ShopAndDine/Redirect/AddEditRedirect";
import { CentralizedAddEditServicesCatPageContent } from "~/Modules/Centralized/Forms/ShopAndDine/Services/ServicesCategories/AddEditServicesCatPageContent";
import { CentralizedAddEditServicesListPageContent } from "~/Modules/Centralized/Forms/ShopAndDine/Services/ServicesList/AddEditServicesListPageContent";
import { CentralizedAddEditShopCatPageContent } from "~/Modules/Centralized/Forms/ShopAndDine/Shop/ShopCategories/AddEditShopCatPageContent";
import { CentralizedAddEditShopListPageContent } from "~/Modules/Centralized/Forms/ShopAndDine/Shop/ShopList/AddEditShopListPageContnet";
import { CentralizedShopAndDine } from "~/Modules/Centralized/Forms/ShopAndDine/ShopAndDine";
import { CentralizedAddEditSource } from "~/Modules/Centralized/Forms/ShopAndDine/Source/AddEditSource";
import { CentralizedAddEditSubCategory } from "~/Modules/Centralized/Forms/ShopAndDine/SubCategories/AddEditSubCategory";
import { CentralizedAddEditTags } from "~/Modules/Centralized/Forms/ShopAndDine/Tags/AddEditTags";
import { CentralizedAddEditType } from "~/Modules/Centralized/Forms/ShopAndDine/Type/AddEditType";
import { CentralizedAddEditLevels } from "~/Modules/Centralized/Forms/ShopAndDine/Zone/Levels/AddEditLevels";
import { CentralizedAddEditPassenger } from "~/Modules/Centralized/Forms/ShopAndDine/Zone/Passenger/AddEditPassenger";
import { CentralizedAddEditPublic } from "~/Modules/Centralized/Forms/ShopAndDine/Zone/Public/AddEditPublic";
import { CentralizedBaggageGuide } from "~/Modules/Centralized/Forms/TravellersInfo/BaggageGuide/BaggageGuide";
import { AddEditCentralizedGuidelinesForCheckedInSection2 } from "~/Modules/Centralized/Forms/TravellersInfo/GuidelinesForCheckedIn/AddEditGuidelinesForCheckedInSection2";
import { CentralizedLagsAndRestrictedItems } from "~/Modules/Centralized/Forms/TravellersInfo/LagsAndRestrictedItems/LagsAndRestrictedItems";
import { AddEditCentralizedLagsGuidelines } from "~/Modules/Centralized/Forms/TravellersInfo/LagsSection/AddEditGuideLines";
import { AddEditCentralizedLagsSection2 } from "~/Modules/Centralized/Forms/TravellersInfo/LagsSection/AddEditLagsSection2";
import { AddEditCentralizedLagsSteps } from "~/Modules/Centralized/Forms/TravellersInfo/LagsSection/AddEditLagsSteps";
import { AddEditCentralizedRestrictedItemsSectionsList } from "~/Modules/Centralized/Forms/TravellersInfo/RestrictedItemsSection/AddEditRestrictedItemsSectionsList";
import { AddEditCentralizedSingleCabinLuggagePolicySection2 } from "~/Modules/Centralized/Forms/TravellersInfo/SingleCabinLuggagePolicySection/AddEditSingleCabinLuggagePolicySection2";
import { CentralizedTravellersInfo } from "~/Modules/Centralized/Forms/TravellersInfo/TravellersInfo";
import { CentralizedUserManagement } from "~/Modules/Centralized/UserManagement/AddNewCentralizedUser";
import { AddEditNonSocialMediaIcons } from "~/Modules/ECMS/CORPORATE/Forms/MainNavigation/WebAppFooter/Icons/AddEditNonSocialMediaIcons";
import { AddEditSocialMediaIcon } from "~/Modules/ECMS/CORPORATE/Forms/MainNavigation/WebAppFooter/Icons/AddEditSocialMediaIcons";
import { SubsidiariesDynamic } from "~/Modules/ECMS/CORPORATE/Forms/SubsidiariesDynamic/SubsidiariesDynamic";
import { AddEditLinks } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/MilestonesNew/Links/AddEditLinks";
import { AddEditOverview } from "~/Modules/ECMS/CORPORATE/Forms/TrainingAcademy/MilestonesNew/Overview/AddEditOverview";
import { AddEditPassengerNonSocialMediaIcons } from "~/Modules/ECMS/PASSENGER/footer/WebAppFooter/Icons/AddEditNonSocialMediaIcons";
import { AddEditPassengerSocialMediaIcon } from "~/Modules/ECMS/PASSENGER/footer/WebAppFooter/Icons/AddEditSocialMediaIcons";
import { HeaderManagment } from "~/Modules/ECMS/PASSENGER/Header/HeaderManagment";
import { AddEditTravllerEssentialsList } from "~/Modules/ECMS/PASSENGER/homepage/TravllerEssential/TravellerEssentialList/AddEditTravellerEssentialsList";
import AddEditAppCard from "~/Modules/ECMS/PASSENGER/mobileapp/appcard/AddEditCard";
import Navigation from "~/Modules/ECMS/PASSENGER/Navigation/Navigation";
import { PageHeaderMenu } from "~/Modules/ECMS/PASSENGER/PageHeader/PageHeaderMenu";
import { AddEditDineCatPageContent } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Dine/DineCategories/AddEditDineCatPageContent";
import { AddEditDineListPageContent } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Dine/DineList/AddEditDineListPageContent";
import { EditDineListPageHeading } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Dine/DineList/EditDineListPageHeading";
import { AddEditLandingPageContent } from "~/Modules/ECMS/PASSENGER/ShopAndDine/LandingPage/AddEditLandingPageContent";
import { AddEditServicesCatPageContent } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Services/ServicesCategories/AddEditServicesCatPageContent";
import { AddEditServicesListPageContent } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Services/ServicesList/AddEditServicesListPageContent";
import { EditServicesListPageHeading } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Services/ServicesList/EditServicesListPageHeading";
import { AddEditShopCatPageContent } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Shop/ShopCategories/AddEditShopCatPageContent";
import { AddEditShopListPageContent } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Shop/ShopList/AddEditShopListPageContnet";
import { EditShopListPageHeading } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Shop/ShopList/EditShopListPageHeading";
import { AddEditLevels } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Zone/Levels/AddEditLevels";
import { AddEditPassenger } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Zone/Passenger/AddEditPassenger";
import { AddEditPublic } from "~/Modules/ECMS/PASSENGER/ShopAndDine/Zone/Public/AddEditPublic";
import { NewTab } from "~/Modules/ECMS/MAGP/Forms/ContractDirectory/NewTab";

interface RouteBase {
  path: string;
  element: ReactNode;
}

interface ProtectedRoutes extends RouteBase {
  roles: string[];
}

export const protectRoutes: ProtectedRoutes[] = [
  {
    path: `/dedicated/default-module`,
    element: <DefaultModule />,
    roles: ["SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/announcements`,
    element: <Announcement />,
    roles: ["SUPER_ADMIN", "MAGP_CREATOR"],
  },
  {
    path: `/user-management`,
    element: <DedicatedUserManagement />,
    roles: ["SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/user-management`,
    element: <MAGPUserManagement />,
    roles: ["MAGP_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/ecms/welcome-page`,
    element: <LandingPage />,
    roles: ["*"],
  },
  {
    path: `/dedicated/magp/manual`,
    element: <Manual />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/manual/procurementPlanning`,
    element: <EditProcurementPlanningProcessFlowChart />,
    roles: ["*"],
  },
  {
    path: `/dedicated/magp/manual/requisition`,
    element: <EditRequisitionProcessFlowChart />,
    roles: ["*"],
  },
  {
    path: `/dedicated/magp/manual/sourcing`,
    element: <EditSourcingProcessFlowChart />,
    roles: ["*"],
  },
  {
    path: `/dedicated/magp/manual/contractAdministration`,
    element: <EditContractAdministrationProcessFlowChart />,
    roles: ["*"],
  },
  {
    path: `/dedicated/magp/manual/vendorManagement`,
    element: <EditVendorManagementProcessFlowChart />,
    roles: ["*"],
  },
  {
    path: `/dedicated/magp/popup`,
    element: <Home />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/others`,
    element: <Others />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/faq`,
    element: <FAQ />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/faq/add`,
    element: <AddEditNewFAQ />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/approval-management`,
    element: <ApprovalManagement />,
    roles: ["MAGP_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/approval-management`,
    element: <ApprovalManagement />,
    roles: ["ERAMAN_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/approval-management`,
    element: <CorporateApprovalManagement />,
    roles: ["MAHB_CORPORATE_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/approval-management`,
    element: <PassengerApprovalManagement />,
    roles: ["PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/status-information`,
    element: <StatusInformation />,
    roles: ["MAGP_CREATOR", "ERAMAN_CREATOR", "SUPER_ADMIN", "MAHB_CORPORATE_CREATOR", "PASSENGER_CREATOR", "PASSENGER_ECMS_CREATOR"],
  },
  {
    path: `/dedicated/magp/login`,
    element: <LoginMAGP />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/profile`,
    element: <Profile />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/ecms/request-access`,
    element: <RequestAccess />,
    roles: ["*"],
  },
  {
    path: `/user-management/add`,
    element: <AddNewDedicatedUser />,
    roles: ["SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/user-management/add`,
    element: <AddNewDedicatedUser />,
    roles: ["MAGP_REVIEWER"],
  },
  {
    path: `/dedicated/magp/announcements/add`,
    element: <AddEditAnnouncement />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/announcements/edit/:id/:type`,
    element: <AddEditAnnouncement />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/media-centre/`,
    element: <MediaCentre />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/corporate-integrity/`,
    element: <CorporateIntegrity />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/homepage/`,
    element: <Homepage />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/access-management`,
    element: <MAGPAccessManagement />,
    roles: ["MAGP_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/corporate-profile/`,
    element: <CorporateProfile />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/subsidiaries/`,
    element: <SubsidiariesDynamic />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/awards/`,
    element: <Awards />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/organization/`,
    element: <Organization />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/stakeholders/`,
    element: <StakeHolder />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/malaysiaairportacademy`,
    element: <MalaysiaAirportAcademy />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/sustainbility`,
    element: <Sustainbility />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/contactus`,
    element: <ContactUs />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/business-oppurtunities/`,
    element: <BusinessOppurtunities />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/butterfly-effect`,
    element: <ButterflyEffect />,
    roles: ["PASSENGER_CREATOR", "PASSENGER_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/homepage`,
    element: <HomepageManagement />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  //  {
  //   path: `/dedicated/passenger/homepage/`,
  //   element: <HomepageManagement/>,
  //   roles: ["PASSENGER_CREATOR", "PASSENGER_REVIEWER", "SUPER_ADMIN"],
  // },
  {
    path: `/dedicated/passenger/navigation/footer`,
    element: <FooterPassenger />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/navigation/footer/icons/socialMedia/add`,
    element: <AddEditPassengerSocialMediaIcon />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/navigation/footer/icons/servicePortals/add`,
    element: <AddEditPassengerNonSocialMediaIcons />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/mobileapp`,
    element: <MobileApp />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/homepage/slider/add`,
    element: <AddEditSlider />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/homepage/youtube/add`,
    element: <AddEditYouTube />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/homepage/travller/add`,
    element: <AddEditTravllerEssential />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/homepage/travellerEssentialsList/add`,
    element: <AddEditTravllerEssentialsList />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/homepage/usefulltips/add`,
    element: <AddEditusefullTip />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/homepage/spotlight/card/add`,
    element: <AddEditcards />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/homepage/spotlight/page/add`,
    element: <AddEditPage />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/homepage/spotlight/highlight/add`,
    element: <AddEditHighlight />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/footer/footerlogo/add`,
    element: <AddEditFooterLogo />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/footer/footerwebsite/add`,
    element: <AddEditFooterWebsite />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/flight-information/add`,
    element: <AddEditFlightinfo />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/pageheader/pageheader/add`,
    element: <AddEditHeader />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/pageheader`,
    element: <PageHeaderMenu />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/flight-information`,
    element: <Flightinfo />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/maps`,
    element: <Maps />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/maps/airportLocations/add`,
    element: <AddEditAirportLocation />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/maps/parentAirport/add`,
    element: <AddEditParentAirport />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/maps/childAirport/add`,
    element: <AddEditChildAirport />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/help`,
    element: <Help />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/help/pageContent/add`,
    element: <AddEditPageContent />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine`,
    element: <ShopAndDine />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/landingPage/add`,
    element: <AddEditLandingPageContent />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/shop/shopCategories/shopCategoriesPageContent/add`,
    element: <AddEditShopCatPageContent />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/shop/shopList/shopListPageContent/add`,
    element: <AddEditShopListPageContent />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/dine/dineCategories/dineCategoriesPageContent/add`,
    element: <AddEditDineCatPageContent />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/dine/dineList/dineListPageContent/add`,
    element: <AddEditDineListPageContent />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/services/servicesCategories/servicesCategoriesPageContent/add`,
    element: <AddEditServicesCatPageContent />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/services/servicesList/servicesListPageContent/add`,
    element: <AddEditServicesListPageContent />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/shop/shopList/shopListPageHeading/edit`,
    element: <EditShopListPageHeading />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/dine/dineList/dineListPageHeading/edit`,
    element: <EditDineListPageHeading />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/services/servicesList/servicesListPageHeading/edit`,
    element: <EditServicesListPageHeading />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/navigation`,
    element: <Navigation />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passanger/header/cardheader/add`,
    element: <AddEditCardHeaderPas />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/user-management/add`,
    element: <AddNewDedicatedUser />,
    roles: ["PASSENGER_ECMS_REVIEWER"],
  },
  {
    path: `/dedicated/passenger/user-management`,
    element: <PASSENGERUserManagement />,
    roles: ["PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/dashboard`,
    element: <Dashboard />,
    roles: ["MAGP_REVIEWER", "MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/dashboard`,
    element: <EramanDashboard />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/product-management`,
    element: <ProductManagement />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/feedback-submissions`,
    element: <FormsSubmissions />,
    roles: ["ERAMAN_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/newsletterSubscription`,
    element: <Members />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman//user-transactions`,
    element: <UserTransactions />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/advertisement`,
    element: <Advertisement />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/advertisement/homePageCarousel/add`,
    element: <AddEditHomePageCarousel />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/advertisement/campaign/add`,
    element: <AddEditNewPromotions />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/pages`,
    element: <Pages />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/storeLocations`,
    element: <StoreLocations />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/header`,
    element: <Header />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/footer`,
    element: <Footer />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/configuration`,
    element: <Configuration />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/product-reviews`,
    element: <ProductReviews />,
    roles: ["ERAMAN_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/configuration-users/add`,
    element: <AddEditNewUsers />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/configuration-edmMailer/add`,
    element: <AddEditNewEdmMailer />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/configuration-newsLetter/add`,
    element: <AddNewsLetter />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/configuration-promotions/add`,
    element: <AddEditPromotions />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/registeredUsers/add`,
    element: <AddEditMembers />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/epc-applications/add`,
    element: <AddEditEpcApplications />,
    roles: ["ERAMAN_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/storeLocations/airport/add`,
    element: <AddEditStoreAirport />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/storeLocations/level/add`,
    element: <AddEditStoreLevel />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/storeLocations/outlet/add`,
    element: <AddEditStoreOutlet />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/product-management/subCategories/add`,
    element: <AddEditSubCategories />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/product-management/categories/add`,
    element: <AddEditCategories />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/product-management/productBrand/add`,
    element: <AddEditBrands />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/product-management/products/add`,
    element: <AddEditProducts />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/product-management/food-and-beverages-brand/add`,
    element: <FAndBAddEditBrand />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/product-management/food-and-beverages-outlet/add`,
    element: <FAndBAddEditOutlet />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/product-management/food-and-beverages-category/add`,
    element: <AddEditFAndBAddEditCategory />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/pages/aboutEraman/news/add`,
    element: <AddEditNews />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/pages/aboutEraman/careers/jobOpportunities/add`,
    element: <AddEditJobOpportunities />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/pages/eramanPrivilegeCard/Faqs/add`,
    element: <AddEditEramanFaqs />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/pages/aboutEraman/awards/awardsList/add`,
    element: <AddEditAwards />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/footer/socialMediaIcons/add`,
    element: <AddEditSocialMediaIcons />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/footer/contents/add`,
    element: <AddEditContent />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/header/categoryBanner/add`,
    element: <AddEditCategoryBanner />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/header/menuHeader/add`,
    element: <EditMenuHeader />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/header`,
    element: <HeaderManagment />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/form-submissions/contest/users`,
    element: <Participants />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/epc-applications`,
    element: <EpcApplications />,
    roles: ["ERAMAN_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/user-management`,
    element: <EramanUserManagement />,
    roles: ["ERAMAN_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/user-management/add`,
    element: <AddNewDedicatedUser />,
    roles: ["ERAMAN_REVIEWER"],
  },
  {
    path: `/dedicated/corporate/training-academy`,
    element: <TrainingAcademy />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/awards/add`,
    element: <AddEditCorporateAwards />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/homepagebanner/add`,
    element: <AddEditCorporatesHomepage />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/mobileapp/cards/add`,
    element: <AddEditAppCard />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  // {
  //   path: `/dedicated/passenger/mobileapp/about/add`,
  //   element: <AddEditAbout />,
  //   roles: ["PASSENGER_CREATOR", "SUPER_ADMIN"],
  // },
  {
    path: `/dedicated/passenger/mobileapp/header/add`,
    element: <AddEditFeature />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/spotlight/smallcards/add`,
    element: <AddEditSpotlightSmallcards />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/spotlight/largecards/add`,
    element: <AddEditSpotlightLargecards />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/publications/add`,
    element: <AddEditPublications />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/business-opportunities/commercialLeasingOpportunities/retailOutletList/add`,
    element: <AddEditCommercialLeasingOpportunities />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/business-opportunities/commercialLeasingOpportunities/foodAndBeverageList/add`,
    element: <AddEditCommercialLeasingOpportunities />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/business-opportunities/commercialLeasingOpportunities/serviceOutletList/add`,
    element: <AddEditCommercialLeasingOpportunities />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/business-opportunities/commercialLeasingOpportunities/othersList/add`,
    element: <AddEditCommercialLeasingOpportunities />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/business-oppurtunities/airlineServices/airlineServicesFacilities/add`,
    element: <AddEditAirlineServicesAndIncentives />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/media-centre/news/add`,
    element: <AddEditCorporateNews />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/navigation`,
    element: <MainNavigation />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/training-academy/navigation/parentHeader/add`,
    element: <AddEditParentHeader />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/training-academy/navigation/childHeader/add`,
    element: <AddEditChildHeader />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/training-academy/navigation/grandChildHeader/add`,
    element: <AddEditGrandChildHeader />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/training-academy/trainingFacilities/add`,
    element: <AddEditTrainingFacilities />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/training-academy/milestones/add`,
    element: <AddEditMilestones />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/training-academy/banner/add`,
    element: <AddEditTrainingAcademyBanner />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/training-academy/news/add`,
    element: <AddEditTrainingAcademyNews />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/gallery`,
    element: <GalleryList />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/contact-directory`,
    element: <ContractDirectory />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/contact-directory/edit`,
    element: <NewTab />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/manual/hyperlink/add`,
    element: <AddEditHyperlink />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/navigation/header/child/add`,
    element: <AddEditChildHeaderPas />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/navigation/header/main/add`,
    element: <AddEditMainHeaderPas />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/navigation/header/grandchild/add`,
    element: <AddEditGrandChildHeaderPas />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/navigation/header/grandchild/add`,
    element: <AddEditGrandChildHeaderPas />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/navigation/header/cardheader/add`,
    element: <AddEditCardHeaderPas />,
    roles: ["PASSENGER_ECMS_CREATOR", "PASSENGER_ECMS_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/announcements/general/add`,
    element: <AddEditNewGeneral />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/announcements/circular/add`,
    element: <AddEditNewCircular />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/gallery/add`,
    element: <AddNewGallery />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/contact-directory/:contactDirKey/add`,
    element: <AddEdit />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
    {
    path: `/dedicated/magp/contact-directory/add`,
    element: <AddNewCD />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/login/webLoginPage/add`,
    element: <AddEditWebLoginPage />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/others/banners/webBannerImages/add`,
    element: <AddEditWebBannerImages />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/magp/others/banners/mobileHomepageBannerSlider/add`,
    element: <AddEditMobileHomepageBannerSlider />,
    roles: ["MAGP_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/organization/managementTeam/add`,
    element: <AddEditManagementTeam />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/organization/boardOfDirectors/add`,
    element: <AddEditBoardOfDirectors />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/stakeholders/agencies/add`,
    element: <AddEditAgencies />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/stakeholders/airlines/add`,
    element: <AddEditAirlines />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/stakeholders/cargo/add`,
    element: <AddEditCargo />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/stakeholders/groundHandlers/add`,
    element: <AddEditGroundHolders />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/pages/travellersInfo/dutyFreeBuyingGuide/add`,
    element: <AddEditDutyFreeBuyingGuide />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/contents`,
    element: <Contents />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/pages/travellersInfo/singleCabinLuggagePolicy/singleCabinLuggagePolicyPageImage/add`,
    element: <AddEditSingleCabinLuggagePolicySection2 />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/pages/travellersInfo/guidelinesForCheckedinLuggage/guidelinesForCheckedinLuggagePageImage/add`,
    element: <AddEditGuidelinesForCheckedInSection2 />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/pages/travellersInfo/lags/lagsLiquidItemImage/add`,
    element: <AddEditLagsSection2 />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/eraman/pages/travellersInfo/restrictedItems/add`,
    element: <AddEditRestrictedItemsSectionsList />,
    roles: ["ERAMAN_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/navigation/mainMenu/add`,
    element: <AddEditMainMenu />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/navigation/childMenus/add`,
    element: <AddEditChildMenus />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/navigation/grandChildMenus/add`,
    element: <AddEditGrandChildMenus />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/navigation/webAppFooter/socialMedia/add`,
    element: <AddEditSocialMediaIcon />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/navigation/webAppFooter/servicePortals/add`,
    element: <AddEditNonSocialMediaIcons />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/training-academy/local-client/add`,
    element: <AddEditLocalClients />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },

  {
    path: `/dedicated/corporate/training-academy/international-client/add`,
    element: <AddEditInternationalClients />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/training-academy/milestone-overview/add`,
    element: <AddEditOverview />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/corporate/training-academy/milestone-link/add`,
    element: <AddEditLinks />,
    roles: ["MAHB_CORPORATE_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/zonePassenger/add`,
    element: <AddEditPassenger />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/zonePublic/add`,
    element: <AddEditPublic />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/dedicated/passenger/shopAndDine/zoneLevels/add`,
    element: <AddEditLevels />,
    roles: ["PASSENGER_ECMS_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedBanner`,
    element: <CentralizedBannerTab />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedBanner/add`,
    element: <AddEditCentralizedBanner />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedBannerType/add`,
    element: <AddEditCentralizedBannerType />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedBannerTags/add`,
    element: <AddEditCentralizedBannerTags />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedModules`,
    element: <CentralizedModules />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedModules/add`,
    element: <AddEditCentralizedModules />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/privacyPolicy`,
    element: <CentralisedPrivacyPolicy />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/privacyPolicy/tab-1/add`,
    element: <AddEditTabOne />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  // {
  //   path: `/centralized/privacyPolicy/tab-2/add`,
  //   element: <AddEditTabTwo />,
  //   roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  // },
  {
    path: `/centralized/privacyPolicy/privacyPolicyTabOne/add`,
    element: <AddEditTabOnePara />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  // {
  //   path: `/centralized/privacyPolicy/paragraph/tab-2/add`,
  //   element: <AddEditTabTwoPara />,
  //   roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  // },
  {
    path: `/centralized/privacyPolicy/myAirportsPrivacyPolicy/add`,
    element: <AddEditMyAirports />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedFaqs`,
    element: <CentralizedFaqsTab />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedFaqs/centralizedQandAs/add`,
    element: <AddEditCentralizedFaqs />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedFaqs/centralizedFaqsCategories/add`,
    element: <AddEditCentralisedKeyInfoList />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedFaqs/centralizedKeyInfoBanner/add`,
    element: <AddEditCentralisedKeyInfoBanner />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedAirlineTailImage`,
    element: <CentralisedAirlineImages />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedAirlineTailImage/add`,
    element: <AddEditCentralizedAirlineImages />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedTravellersInfo`,
    element: <CentralizedTravellersInfo />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedBaggageGuide`,
    element: <CentralizedBaggageGuide />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedLagsAndRestrictedItems`,
    element: <CentralizedLagsAndRestrictedItems />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine`,
    element: <CentralizedShopAndDine />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },

  {
    path: `/centralized/centralizedShopAndDine/shop/centralizedShopCategoriesPageContent/add`,
    element: <CentralizedAddEditShopCatPageContent />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/shop/centralizedShopListPageContent/add`,
    element: <CentralizedAddEditShopListPageContent />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/dine/centralizedDineCategoriesPageContent/add`,
    element: <CentralizedAddEditDineCatPageContent />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/dine/centralizedDineListPageContent/add`,
    element: <CentralizedAddEditDineListPageContent />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/services/centralizedServicesCategoriesPageContent/add`,
    element: <CentralizedAddEditServicesCatPageContent />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/services/centralizedServicesListPageContent/add`,
    element: <CentralizedAddEditServicesListPageContent />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/zone/centralizedZonePassenger/add`,
    element: <CentralizedAddEditPassenger />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/zone/centralizedZonePublic/add`,
    element: <CentralizedAddEditPublic />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/zone/centralizedZoneLevels/add`,
    element: <CentralizedAddEditLevels />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/centralizedTags/add`,
    element: <CentralizedAddEditTags />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/centralizedList/add`,
    element: <CentralizedAddEditList />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/centralizedBrands/add`,
    element: <CentralizedAddEditBrand />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/centralizedType/add`,
    element: <CentralizedAddEditType />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/centralizedCategory/add`,
    element: <CentralizedAddEditCategory />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/centralizedSubCategory/add`,
    element: <CentralizedAddEditSubCategory />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/centralizedDataClassification/add`,
    element: <CentralizedAddEditClassification />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/centralizedSource/add`,
    element: <CentralizedAddEditSource />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/centralizedLocation/add`,
    element: <CentralizedAddEditLocation />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedShopAndDine/centralizedRedirectUrl/add`,
    element: <CentralizedAddEditRedirect />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },

  {
    path: `/centralized/centralizedPromotion`,
    element: <MyAirportsPromotionsManagement />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedPromotion/notificationType/add`,
    element: <AddEditNotificationType />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedPromotion/repeatType/add`,
    element: <AddEditRepeatType />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedPromotion/geoLocationPromotions/add`,
    element: <AddEditGeoLocationPromotion />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedPromotion/geoLocationPromotionLevels/add`,
    element: <AddEditGeoLocationLevels />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedPromotion/geoLocationOffer/add`,
    element: <AddEditGeoLocation />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedPromotion/promotion/add`,
    element: <AddEditMyairportsPromotion />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },

  {
    path: `/centralized/centralizedBaggageGuide/centralizedSingleCabinLuggagePolicy/centralizedSingleCabinLuggagePolicyPageImage/add`,
    element: <AddEditCentralizedSingleCabinLuggagePolicySection2 />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedBaggageGuide/centralizedGuidelinesForCheckedinLuggage/centralizedGuidelinesForCheckedinLuggagePageImage/add`,
    element: <AddEditCentralizedGuidelinesForCheckedInSection2 />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedLagsAndRestrictedItems/centralizedLags/centralizedLagsLiquidItemImage/add`,
    element: <AddEditCentralizedLagsSection2 />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },

  {
    path: `/centralized/centralizedLagsAndRestrictedItems/centralizedLags/centralizedLagsGuidelinesContent/add`,
    element: <AddEditCentralizedLagsGuidelines />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedLagsAndRestrictedItems/centralizedLags/centralizedLagsSteps/add`,
    element: <AddEditCentralizedLagsSteps />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedLagsAndRestrictedItems/centralizedRestrictedItems/add`,
    element: <AddEditCentralizedRestrictedItemsSectionsList />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/status-information`,
    element: <CentralizedStatusInformation />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedPromotions`,
    element: <CentralisedPromotions />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/centralizedPromotions/add`,
    element: <AddEditCentralizedPromotions />,
    roles: ["CENTRALIZED_CREATOR", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/approval-management`,
    element: <CentralizedApprovalManagement />,
    roles: ["CENTRALIZED_REVIEWER", "SUPER_ADMIN"],
  },
  {
    path: `/centralized/user-management?activeTab=activeUsers`,
    element: <CentralizedUserManagement />,
    roles: ["CENTRALIZED_REVIEWER", "SUPER_ADMIN"],
  },
];
export const openRoutes: ProtectedRoutes[] = [
  {
    path: `/auth/ecms`,
    element: <CMS />,
    roles: ["*"],
  },
  {
    path: `/auth/centralized/modules`,
    element: <Centralized />,
    roles: ["*"], //["SUPER_ADMIN"],
  },
  {
    path: `/auth/dedicated/modules`,
    element: <Dedicated />,
    roles: ["*"], //SUPER_ADMIN
  },
  {
    path: `/auth/dedicated/passenger/airport`,
    element: <PassengerAirports />,
    roles: ["*"], //SUPER_ADMIN
  },
];

export const globalRoutes = [
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/auth/login/otp",
    element: <OtpLoginPage />,
  },
  {
    path: "/auth/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "auth/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "auth/get-password",
    element: <GetLoginPassword />,
  },
  {
    path: "auth/forgot-password-otp",
    element: <OtpPasswordPage />,
  },
  {
    path: "auth/new-password",
    element: <ConfirmNewPassword />,
  },
  // {
  //   path: "/unauthorized-entry",
  //   element: <UnAuthorized />,
  // },
];
